"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StatusLabelAppearance = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const StatusLabelAppearance = exports.StatusLabelAppearance = {
  CAUTION: "caution",
  DEFAULT: "",
  INFORMATION: "information",
  NEGATIVE: "negative",
  POSITIVE: "positive"
};

/**
 * The type of the StatusLabel props.
 */

/**
 * This is a [React](https://reactjs.org/) component for the Vanilla [Label](https://vanillaframework.io/docs/patterns/labels).
 *
 * Labels are static elements which you can apply to signify status, tags or any other information you find useful.
 */
const StatusLabel = _ref => {
  let {
    appearance,
    children,
    className,
    ...labelProps
  } = _ref;
  const classes = (0, _classnames.default)(appearance ? "p-status-label--".concat(appearance) : "p-status-label", className);
  return /*#__PURE__*/_react.default.createElement("div", _extends({}, labelProps, {
    className: classes
  }), children);
};
var _default = exports.default = StatusLabel;